import axiosInstance from "./axiosInstance";

const RETRY_DELAYS_MS = [1000, 3000];

/**
 * Records the provider of a finished attempt. The customer's outcome does not
 * depend on it, so it retries on its own and only logs a final failure.
 */
export const recordProvider = async ({
  ceviantTransactionId,
  provider,
}: {
  ceviantTransactionId: string;
  provider: string;
}) => {
  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
    try {
      await axiosInstance.put(
        `/transactions/provider`,
        { ceviantTransactionId, provider },
        {
          params: { ceviantTransactionId, provider },
        }
      );
      return;
    } catch (error) {
      if (attempt === RETRY_DELAYS_MS.length) {
        console.error('Error recording the transaction provider:', error);
        return;
      }

      await new Promise((resolve) =>
        setTimeout(resolve, RETRY_DELAYS_MS[attempt])
      );
    }
  }
};
